const EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}(\.[0-9]{1,3}){3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const WEBSITE_PATTERN = /^(?:www\.)?[\w-]+(?:\.[\w-]+)+(?:[/?#][^\s]*)?$/i;

export function validateHeadOfficeRecord(record) {
    if (!String(record?.tenant_name || "").trim()) {
        return [false, "Tenant Name is required."];
    }
    if (record.email && !EMAIL_PATTERN.test(String(record.email).trim())) {
        return [false, "The email is not a correct format"];
    }
    if (record.weburl && !WEBSITE_PATTERN.test(String(record.weburl).trim())) {
        return [false, "The url (website) is not a correct format. Please enter www.{}.{}"];
    }
    return [true, ""];
}